import {
  clearOldInteractionsEntries,
  STORAGE_KEYS,
  universalTrackRoomClicked,
} from '@/services/interactions-tracker';

export function trackRoomClicked(roomId) {
  universalTrackRoomClicked(STORAGE_KEYS.LOCATION_PAGE, roomId);
}

export function clearOldLocationPageInteractionsEntries() {
  clearOldInteractionsEntries(STORAGE_KEYS.LOCATION_PAGE);
}
